<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative; max-height: 320px">
      <Spin v-if="loadingStatus" fix />
      <Form ref="tempParkingForm" :label-width="100" :model="formFields" :rules="ruleValidate">
        <FormItem label="过期时间:" prop="expireTime">
          <DatePicker
            v-model="formFields.expireTime"
            size="small"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请输入过期时间..."
            style="width: 100%"
            @on-change="onExpireTimeChange"
          />
        </FormItem>
        <FormItem label="过期状态:">
          <span style="font-size: 9pt">{{ isExpired(formFields.expireTime) ? '未过期' : '已过期' }}</span>
        </FormItem>
        <FormItem label="临停车库:" prop="parking">
          <Input
            v-model="formFields.parking"
            size="small"
            :disabled="true"
          />
        </FormItem>
        <FormItem label="剩余开门次数:" prop="remainOpeningTimes">
          <Input
            v-model="formFields.remainOpeningTimes"
            placeholder="请输入剩余开门次数..."
            size="small"
          />
        </FormItem>
        <FormItem label="提醒次数:" prop="reminderTimes">
          <Input
            v-model="formFields.reminderTimes"
            placeholder="请输入提醒次数..."
            size="small"
          />
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject, isBefore, formatDate } from '@/utils/util'
export default {
  name: 'TemporaryVehicleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    icon: {
      type: String,
      default: '"md-create'
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      modal: true,
      submit: false,
      loadingStatus: false,
      formFields: {
        id: this.id,
        expireTime: '',
        parking: '',
        remainOpeningTimes: '',
        reminderTimes: ''
      },
      ruleValidate: {
        expireTime: [
          { required: true, message: '过期时间不能为空!' }
        ]
      }
    }
  },
  computed: {
    action() {
      return this.$config.apiContextPath + '/temporary/parking/' + this.id
    },
    title() {
      return this.caption || '临停编辑'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadData()
    }
  },
  methods: {
    isExpired(date) {
      return isBefore(date)
    },
    onExpireTimeChange: function(date) {
      this.formFields.expireTime = date
    },
    loadData() {
      this.loadingStatus = false
      if (this.id) {
        this.loadingStatus = true
        request({
          url: this.action,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          applyObject(res.data, this.formFields)
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    },
    resetForm: function() {
      this.$refs.tempParkingForm.resetFields()
    },
    saveOrUpdate: function() {
      this.$refs.tempParkingForm.validate((valid) => {
        if (valid) {
          this.submit = true
          if (this.formFields.expireTime) {
            this.formFields.expireTime = formatDate(new Date(this.formFields.expireTime), 'yyyy-MM-dd hh:mm:ss')
          }
          request({
            url: this.action,
            method: 'PUT',
            data: this.formFields
          }).then(res => {
            this.$Notice.success({
              title: '临停编辑成功'
            })
            this.submit = false
            this.closeModal(true)
          }).catch(() => {
            this.submit = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

